export const MOBILE_VIEW_CARD_COUNT = 1;
export const TABLET_VIEW_CARD_COUNT = 2;
export const DESKTOP_VIEW_CARD_COUNT = 3;

export const SCROLLING_DIV_ID = "eventScrollingDiv";
